import { useEffect, useRef } from "react";
import { getClassName } from "~/utils/utils";

import "./style.less";

interface IMainVideo {
	className?: string;
	title?: string;
}

export default function MainVideo({
	className = "mainvideo",
	title = "",
}: IMainVideo) {
	const refVideo = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		if (refVideo.current) {
			refVideo.current.muted = true;
			refVideo.current.defaultMuted = true;
		}
	}, []);

	return <div className={getClassName(["mainVideo", className])}>
		<video src="/img/video.mp4" poster="/img/video-cover.jpg" autoPlay={true} loop={true} muted={true} ref={refVideo} playsInline={true} />
		{ title && <span className="mainVideo__title" dangerouslySetInnerHTML={{ __html: title }} /> }
	</div>;
}
